import { render, staticRenderFns } from "./santakButton.vue?vue&type=template&id=b5822224&scoped=true&"
import script from "./santakButton.vue?vue&type=script&lang=js&"
export * from "./santakButton.vue?vue&type=script&lang=js&"
import style0 from "./santakButton.vue?vue&type=style&index=0&id=b5822224&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5822224",
  null
  
)

export default component.exports